import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/shared/ui/LoadingSpinner';
import { useUIStore } from '@/stores/useUIStore';

/**
 * Wrapper component that handles password reset flow
 * Opens reset password modal when user clicks reset link from email
 */
export const ResetPasswordWrapper = () => {
    const { openAuthModal } = useUIStore();
    const navigate = useNavigate();

    useEffect(() => {
        // Detect password recovery token in URL hash
        // Supabase typically redirects back with #access_token=...&type=recovery
        const hash = window.location.hash;
        if (hash) {
            const hashParams = new URLSearchParams(hash.replace('#', '?'));
            const type = hashParams.get('type');
            const token = hashParams.get('access_token');

            if (token && (type === 'recovery' || type === 'signup')) {
                openAuthModal('reset-password', token);
                // Redirigir a inicio para que el fondo sea la web y no el spinner
                navigate('/', { replace: true });
            } else if (token) {
                // Si es un magic link sin type=recovery
                openAuthModal('reset-password', token);
                navigate('/', { replace: true });
            } else {
                // Si hay hash pero no token, redirigir
                navigate('/', { replace: true });
            }
        } else {
            // Si no hay hash, redirigir a inicio por seguridad
            navigate('/', { replace: true });
        }
    }, [openAuthModal, navigate]);

    return <LoadingSpinner size="sm" message="Verificando enlace..." />;
};
